import { ReqX } from "IZOX/STATIC";

class AuthCode {

  static async VerifyRegister(authCode, username, password){
    let res = await ReqX.SendBE("/CommonAPI/AuthCode/VerifyRegister",
      {
        authCode, username, password
      }, null, null);
    return res;
  }

  static async VerifyChangePassword(authCode, password, oldPassword){
    let res = await ReqX.SendBE("/CommonAPI/AuthCode/VerifyChangePassword",
      {
        authCode, password, oldPassword
      }, null, null);
    return res;
  }

  static async ResetPassword(authCode, newPassword){
    let res = await ReqX.SendBE("/CommonAPI/AuthCode/ResetPassword",
      {
        authCode, newPassword
      }, null, null);
    return res;
  }

  static async Authorize(authCode, username, password){
    let res = await ReqX.SendBE("/CommonAPI/AuthCode/Authorize",
      {
        authCode, username, password
      }, null, null);
    return res;
  }

}

export default AuthCode;